// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin__BookingsController from "./admin/bookings_controller"
application.register("admin--bookings", Admin__BookingsController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MultiStepFormController from "./multi_step_form_controller"
application.register("multi-step-form", MultiStepFormController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import CleaveController from "./cleave_controller"
application.register("cleave", CleaveController)

import SweetAlertController from "./sweet_alert_controller"
application.register("sweet-alert-modal", SweetAlertController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import SpecialistSettingsController from "./specialist_settings_controller"
application.register("specialist-settings", SpecialistSettingsController)

import ProfileCalendarController from "./profile_calendar_controller"
application.register("profile-calendar", ProfileCalendarController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

// Needs to be the last controller registered
import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)
